import { Component, OnInit } from '@angular/core';

class model{
}

@Component({
	templateUrl: './rulesRegulations.component.html',
	styleUrls: ['./rulesRegulations.component.css']
})

export class RulesRegulationsComponent implements OnInit {
	public m: model;
	ngOnInit() {
		this.m = new model();
	}
}


// WEBPACK FOOTER //
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/academics/rulesRegulations.component.ts